/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './Currency';

/**
 * 
 * @export
 * @interface TopupPrepaidByOperator
 */
export interface TopupPrepaidByOperator {
    /**
     * 
     * @type {number}
     * @memberof TopupPrepaidByOperator
     */
    amount: number;
    /**
     * 
     * @type {Currency}
     * @memberof TopupPrepaidByOperator
     */
    currency: Currency;
    /**
     * 
     * @type {string}
     * @memberof TopupPrepaidByOperator
     */
    billingLaundryGroupId?: string;
}

/**
 * Check if a given object implements the TopupPrepaidByOperator interface.
 */
export function instanceOfTopupPrepaidByOperator(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "currency" in value;

    return isInstance;
}

export function TopupPrepaidByOperatorFromJSON(json: any): TopupPrepaidByOperator {
    return TopupPrepaidByOperatorFromJSONTyped(json, false);
}

export function TopupPrepaidByOperatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopupPrepaidByOperator {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'currency': CurrencyFromJSON(json['currency']),
        'billingLaundryGroupId': !exists(json, 'billingLaundryGroupId') ? undefined : json['billingLaundryGroupId'],
    };
}

export function TopupPrepaidByOperatorToJSON(value?: TopupPrepaidByOperator | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'currency': CurrencyToJSON(value.currency),
        'billingLaundryGroupId': value.billingLaundryGroupId,
    };
}

